// eslint-disable-next-line import/prefer-default-export
export const getBodyElement = () => document.getElementsByTagName('body')[0];
